import '../product-detail-v4/old.less'
import '../photovolatic-collection/index.less'
import './index.less'
import '../five-kwh-market/sections/five-kwh-banner/index.less'
import PhotovolaticSaveElectric from "../photovolatic-collection/sections/photovolatic-save-electricity"
import PhotovolaticFindOut from "../photovolatic-collection/sections/photovolatic-find-out"
import PhotovolaticCommentList from "../photovolatic-collection/sections/photovolatic-comment-list"
import PhotovolaticSetup from "../photovolatic-collection/sections/photovolatic-setup"
import PhotovolaticForHome from "../photovolatic-collection/sections/photovolatic-for-home"
import { getCouponInfo, shopifyCartAdd } from '../../common/utils/fetch.js'
import { copyString, createCartAndCheckout } from '../../common/utils/index.js'
import { formatMoney } from '@shopify/theme-currency'
import { RegularBanner } from '../five-kwh-market/sections/five-kwh-banner/index_multi';

document.addEventListener('DOMContentLoaded', () => {
  try { // 旧优惠券
    if (!customElements.get("product-coupon")) {
      customElements.define('product-coupon', class ProductCoupon extends HTMLElement {
        constructor() {
          super()
          this.selectors = {
            container: $(this).find(".coupon")
          }
          this.variantId = this.selectors.container.attr("data-variant-id")
          this.successtips = this.selectors.container.attr("data-copysuccess") || "Success"
          this.copyAndUseText = this.selectors.container.attr("data-copy-and-use-text")
          this.codeText = this.selectors.container.attr("data-code-text")
          this.offText = this.selectors.container.attr("data-off-text")

          this.init(this.variantId, this.variantPrice)
        }
        init(variantId) {
          const DOM = this.selectors.container
          DOM.empty();

          let id = variantId
          let price = null
          const current_vairant = document.querySelector("variant-fields")?.currentVariant || null
          if (!current_vairant) {
            price = Number(document.querySelector(".product--price").getAttribute("data-price")) / 100 || 1000
            id = variantId || document.querySelector("product-form").querySelector('[name=id]').value
          } else {
            price = current_vairant.price
            id = current_vairant.id
          }

          getCouponInfo(id, price).then((r) => {
            if (r.data.constructor === Array) { return }

            let begin = r.data.begin_time_str.replace(/-/g, "/");
            let end = r.data.end_time_str.replace(/-/g, "/");

            const h = `
                    <svg viewBox="0 0 346 94.2">
                      <style type="text/css">.st5{font-weight: 600;}._middle {font-weight: 500; font-size:14px; fill:#fff; text-anchor: middle;}._m {dominant-baseline: middle;}._d {dominant-baseline: alphabetic;}</style>
                      <path fill="#FD5000" d="M214,0.2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h108c0,4.4,3.6,8,8,8v78c-4.4,0-8,3.6-8,8l-108.1,0 c0-0.3,0.1-0.7,0.1-1c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8c0,0.3,0,0.7,0.1,1L8,94.2c0-4.4-3.6-8-8-8v-78c4.4,0,8-3.6,8-8H214z M222,67.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12C223,67.7,222.6,67.2,222,67.2z M222,49.2c-0.6,0-1,0.4-1,1v12 c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12C223,49.7,222.6,49.2,222,49.2z M222,31.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1 c0.6,0,1-0.4,1-1v-12C223,31.7,222.6,31.2,222,31.2z M222,13.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12 C223,13.7,222.6,13.2,222,13.2z"/>
                      <polygon fill="#FFC879" points="21.8,0 0,21.8 0,60.9 60.9,0" />
                      <text transform="matrix(0.7 -0.7 0.7 0.7 7 40)" fill="#946040" font-size="8" class="st5">${this.copyAndUseText}</text>
                      <text class="_middle _d" x="120" y="55">
                        <tspan style="display:${r.data.type === 2 ? 'none' : 'inline-block'};">${r.data.currency}</tspan>
                        <tspan class="st5" font-size="45">${r.data.discount}</tspan>
              
                        <tspan class="st5" font-size="45" style="display:${r.data.type === 2 ? 'inline-block' : 'none'};">%</tspan>
              
                        <tspan>${r.data.type === 1 ? "" : `${this.offText}`}</tspan>
                      </text>
                      <text transform="matrix(1 0 0 1 118 76)" class="_middle _m">${begin}-${end}</text>
                      <text transform="matrix(1 0 0 1 284 76)" class="_middle _m">${this.codeText}:${r.data.coupon_code}</text>
                      <circle fill="none" stroke-width="1px" stroke="#fff" cx="285" cy="38.2" r="24.5" />
                      <text transform="matrix(1 0 0 1 266 47)" fill="#fff" font-size="24" class="st5">GO</text>
                    </svg>
                    `;
            DOM.html(h);

            // 先解除绑定在执行
            DOM.find("svg").unbind("click").click(() => {
              copyString(r.data.coupon_code, () => { pushSuccessMessage(this.successtips) })
            })
          })
        }
      })
    }
  } catch (error) {
    console.log(error)
  }

  // save electric
  try {
    document.querySelector(".photovolatic-save-electricity-wrap") && new PhotovolaticSaveElectric({ el: '.photovolatic-save-electricity-wrap' })
  } catch (error) {
    console.log(error)
  }

  // FindOut 红人视频
  try {
    document.querySelector(".findout-pc-swiper") && new PhotovolaticFindOut({
      pcEl: ".findout-pc-swiper",
      mbEl: ".findout-mb-swiper",
    })
  } catch (error) {
    console.log(error)
  }

  // Comment 案例推荐
  try {
    document.querySelector(".commentlist-pc-swiper") && new PhotovolaticCommentList({
      pcEl: ".commentlist-pc-swiper",
      mbEl: ".commentlist-mb-swiper",
    })
  } catch (error) {
    console.log(error)
  }

  // set-up
  try {
    document.querySelector(".photovolatic-setup-wrap") && new PhotovolaticSetup({ el: '.photovolatic-setup-wrap' })
  } catch (error) {
    console.log(error)
  }

  // for home
  try {
    document.querySelector(".balcony-scale-img-wrap") && new PhotovolaticForHome({ el: '.balcony-scale-img-wrap' })
  } catch (error) {
    console.log(error)
  }

  // 变体选择
  if (!customElements.get('variant-fields')) {
    customElements.define('variant-fields', class VariantFields extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', () => this.onVariantChange());
        this.init()
      }

      init() { // 初始化更新主图
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();
      }

      handleQuantityLimit() {
        if(!this.currentVariant) return
        if(!document.querySelector(".product-info-container quantity-input input")) return
        const quantityField = document.querySelector(".product-info-container quantity-input input")
        if(!this.currentVariant.inventory_quantity) {
          quantityField.setAttribute("data-max", 1)
          quantityField.setAttribute("max", 1)
          return
        }
        quantityField.setAttribute("data-max", this.currentVariant.inventory_quantity)
        quantityField.setAttribute("max", this.currentVariant.inventory_quantity)
      }

      onVariantChange(id) {
        this.updateOptions();
        this.updateMasterId(id);
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses()


        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateWishList();
          this.updateSpecs();
          this.updateBuyItNowStyle()
          this.handleQuantityLimit()
          // 数据埋码
          if (!id) {
            this.GAEvent({
              "product_spu_name": $('.product__title').text(), //识别页面产品spu标题名称text
              "module": "Product Selection",//固定模块命名Product Selection
              "options": this.currentVariant?.title, //主体产品sku文本text
              "corner": this.querySelector(':checked')?.getAttribute('corner'), // 产品角标内容，若无配置则为空
              "action": null, //  点击加号固定命名：plus，点击减号固定命名：minus。在切换产品时候，无点击则为空。输入数字则识别为具体数字。
              "options_price": formatMoney(this.currentVariant?.price, window?.pageInfo?.currency?.money_format), //主体产品现价（黑色字体价格），当地货币
            })
          }
        }

        // 旧优惠券
        const productCoupon = document.querySelector("product-coupon")
        if (productCoupon) {
          setTimeout(() => {
            productCoupon.init && productCoupon.init()
          }, 200)
        }
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('.product-form__input'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
      }

      updateMasterId(id) { // 传入了确定的变体id， 直接执行切换
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });

        if (id && typeof (id) === 'number') {
          this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id == id
          });
        } else {
          this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.options[index] === option;
            }).includes(false);
          });
        }
      }

      updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

        const event_variant_change = new CustomEvent('variantChangeEvent', {
          detail: {
            variant: this.currentVariant,
          }
        });
        document.dispatchEvent(event_variant_change);
      }
      // 更新立即购买按钮样式
      updateBuyItNowStyle() {
        const variant = this.getVariantData().find((variant) => variant.id == this.currentVariant.id)
        if (!variant) return
      }

      updateWishList() {
        if (!document.querySelector("jky-wishlist")) return;
        try {
          document.querySelector("jky-wishlist").select_id = this.currentVariant.id
          document.querySelector("jky-wishlist")?.init?.()
        } catch (e) {
          console.error(e)
        }
      }

      renderProductInfo() { // 更新价格 & 购买按钮状态 & 到货提醒
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')

            // 价格
            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            if (source && destination) destination.innerHTML = source.innerHTML;

            // 变体信息
            const variants_source = html.getElementById(`variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const variants_dom = document.getElementById(`variant-radios-${this.dataset.section}`);
            if (variants_source && variants_dom) variants_dom.innerHTML = variants_source.innerHTML;

            // 到货提醒
            const shortage_dom = document.querySelector(`product-shortage`);
            const shortage_source = html.querySelector(`product-shortage`);
            if (shortage_dom && shortage_source) shortage_dom.innerHTML = shortage_source.innerHTML

            // 粘性购物车
            const sticky_dom = document.querySelector(`jky-sticky-cart`);
            const sticky_source = html.querySelector(`jky-sticky-cart`);
            if (sticky_dom && sticky_source) {
              sticky_dom.innerHTML = sticky_source.innerHTML
              sticky_dom.setAttribute("init-variant-id", sticky_source.getAttribute("init-variant-id"))
              sticky_dom.setAttribute("pd", sticky_source.getAttribute("pd"))
              sticky_dom.init && sticky_dom.init()
            }

            // 会员积分文案
            const destination_points = document.getElementById(`product-points-content--${this.dataset.section}`);
            const source_points = html.getElementById(`product-points-content--${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            if (source_points && destination_points) destination_points.innerHTML = source_points.innerHTML;

            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('visibility-hidden');

            this.toggleAddButton(!this.currentVariant.available, window.pageInfo.strings.soldOut);

            if (document.querySelector('.product-info-container')?.querySelector('quantity-input')) {
              // 设置 数量选择器，ga埋码参数
              const minusQuantityBtn = $('.product-info-container quantity-input').find('.quantity__button[name="minus"]')
              minusQuantityBtn.attr("data-ga-params-options", this?.currentVariant?.title)
              minusQuantityBtn.attr("data-ga-params-corner", this.querySelector(':checked')?.getAttribute('corner'))
              minusQuantityBtn.attr("data-ga-params-options_price", formatMoney(this.currentVariant.price, window?.pageInfo?.currency?.money_format))

              const plusQuantityBtn = $('.product-info-container quantity-input').find('.quantity__button[name="plus"]')
              plusQuantityBtn.attr("data-ga-params-options", this?.currentVariant?.title)
              plusQuantityBtn.attr("data-ga-params-corner", this.querySelector(':checked')?.getAttribute('corner'))
              plusQuantityBtn.attr("data-ga-params-options_price", formatMoney(this.currentVariant.price, window?.pageInfo?.currency?.money_format))
              document.querySelector('.product-info-container').querySelector('quantity-input input').value = 1;
              document.querySelector(".product-info-container .add_cart_error_wrapper") && (document.querySelector(".product-info-container .add_cart_error_wrapper").textContent = '')
              if(this?.currentVariant?.inventory_quantity > 1) {
                document.querySelector(".product-info_block quantity-input .quantity__button[name='plus']") && document.querySelector(".product-info_block quantity-input .quantity__button[name='plus']").removeAttribute("disabled")
              }
            }
          });
      }

      updateVariantInput() { // 更新variant id input
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.setAttribute("data-sku", this.currentVariant.sku)
          input.setAttribute("data-full-gift", this.currentVariant.full_gift)
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);

          const allOptionsValue = selectedOptionOneVariants
            .filter((variant) => variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue, allOptionsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions, allOptionsValue) {
        listOfOptions.forEach((input) => {
          // const input_id = input.getAttribute("id")
          // const label_dom = document.querySelector(`label[for=${input_id}]`)

          if (listOfAvailableOptions.includes(input.getAttribute('value'))) { // 正常可售
            // label_dom.querySelector("span.visually-hidden").innerHTML = ""
          } else {
            if (allOptionsValue.includes(input.getAttribute('value'))) { // soldout
              // label_dom.querySelector("span.visually-hidden").innerHTML = "Soldout"
            } else { // unavailable
              // label_dom.querySelector("span.visually-hidden").innerHTML = "Unavilable"
            }
          }
        });
      }

      /**
      * 设置加购按钮状态
      *
      * @param {boolean} disable - 状态（是否禁用）
      * @param {string} text - 加购按钮显示文案替换
      * @param {boolean} modifyClass
      */
      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span') || productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const buyItNowButton = productForm.querySelector('[name="buy-it-now"]')

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          buyItNowButton?.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
          addButtonText.textContent = text || window.pageInfo.strings.product.soldOut || ''
        } else {
          addButton.removeAttribute('disabled');
          buyItNowButton?.removeAttribute('disabled');
          addButtonText.textContent = window.pageInfo.strings.product.addToCart
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = "Unavailable";
        if (price) price.classList.add('visibility-hidden');
      }

      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        if (!document.querySelector("product-gllerry")) return
        const imageGllerry = document.querySelector("product-gllerry")
        if (!imageGllerry.product_gllery) return
        const target_slide = $(imageGllerry).find(`.product-media__box .swiper-slide[media-id=${this.currentVariant.featured_media.id}]`)
        try {
          imageGllerry.product_gllery.slideTo(target_slide.index(), 1000, false)
        } catch (e) {
          console.error(e)
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      updateSpecs() {
        if (!document.querySelector("product-specs")) return;
        try {
          document.querySelector("product-specs")?.getSpecsInfo(this.currentVariant.id)
          document.querySelector("product-specs")?.getUserManual(this.currentVariant.sku)

          $("product-specs").find(".accordion-header--variant").removeClass("active")
          $("product-specs").find(`.accordion-header--variant[data-id=${this.currentVariant.id}]`).addClass("active")
          $("product-specs")[0] && $("product-specs")[0]?.specVariant(false)
        } catch (e) {
          console.error(e)
        }
      }

      // 数据埋码
      GAEvent(params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event":"ga4Event",
          "event_name":"products_details_page_user_clicks",
          "event_parameters":{
            "current_page": window.location.href, // current page url
            ...params
          }
        });
      }
    })
  }

  // add-to-cart | buy-it-now
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // 捆绑销售
        this.dom__bundled = document.querySelector("#app-bundled-sale")
        this.buyItNowButton = this.form.querySelector('.buy-it-now-custom-btn')
        this.buyItNowButton.addEventListener('click', this.handleBuy.bind(this))

        this.currentVariant = document.querySelector("variant-fields")?.currentVariant

        document.addEventListener('variantChangeEvent', (e) => {
          const currentVariant = e.detail.variant
          if (currentVariant) {
            this.currentVariant = currentVariant
          }
        })

        this.handleQuantityLimit()
      }

      getSelectedVariant() {
        if(!document.querySelector(".product-main-block")) return {};
        if(document.querySelector(".product-main-block").getAttribute("onltvariant") === "true") {
          return JSON.parse(document.querySelector('[type="application/json"][data-selected-variant]').textContent);
        }
      }

      handleQuantityLimit() {
        if(!this.currentVariant) {
          this.currentVariant = this.getSelectedVariant()
        }
        if(!document.querySelector(".product-info-container quantity-input input")) return
        const quantityField = document.querySelector(".product-info-container quantity-input input")
        if(!this.currentVariant.inventory_quantity) {
          quantityField.setAttribute("data-max", 1)
          quantityField.setAttribute("max", 1)
          return
        }
        quantityField.setAttribute("data-max", this.currentVariant.inventory_quantity)
        quantityField.setAttribute("max", this.currentVariant.inventory_quantity)

        if(this.currentVariant.inventory_quantity > 1) {
          document.querySelector(".product-info_block quantity-input .quantity__button[name='plus']") && document.querySelector(".product-info_block quantity-input .quantity__button[name='plus']").removeAttribute("disabled")
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      // 数据埋码
      GAEvent(params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event":"ga4Event",
          "event_name":"products_details_page_user_clicks",
          "event_parameters":{
            "current_page": window.location.href, // current page url
            ...params
          }
        });
      }

      // 新checkout 埋码事件
      GABeginCheckoutEvent(params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event":"ga4Event",
          "event_name":"begin_checkout",
          "event_parameters":{
            "current_page": window.location.href, // current page url
            ...params
          }
        });
      }

      handleErrorMsg(msg) {
        const errWrapper = document.querySelector(".product-info-container .add_cart_error_wrapper")
        if(!errWrapper) return
        errWrapper.toggleAttribute('hidden', !msg);
        errWrapper.textContent = msg
      }

      // Add to cart
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMsg()
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        let items = [];
        const formData = new FormData(this.form);
        const id = formData.get('id');

        const quantity = document.querySelector('quantity-input[data-mian-product-quantity]')?.querySelector('input')?.value || 1;

        // add base product
        const baseProduct = {
          id: Number(id),
          quantity,
          properties: {}
        }
        items.push(baseProduct);

        // 选择了配件 or 推荐产品 先加购配件or推荐产品
        let accesorries_title_str = '' // 数据埋码，收集所有捆绑产品 title
        if (this.dom__bundled && this.dom__bundled.querySelectorAll(":checked").length > 0) {
          const variantSku = this.form.querySelector('[name=id]').dataset.sku
          this.dom__bundled.querySelectorAll(":checked").forEach(item => {
            const quantityInput = item.parentElement.parentElement.querySelector('[data-quantity-input]')
            accesorries_title_str += `${quantityInput.dataset.skuTitle}*${quantityInput.value}*${quantityInput.dataset.skuPrice},`

            items.push({
              id: quantityInput.dataset.skuId,
              quantity: quantityInput.value,
              properties: {
                'Action': 'bundled sale',
                'bundled-sku': variantSku,
              }
            })
          })
        }

        shopifyCartAdd({ items }).then((r) => {
          const el = document.querySelector('product-form form[data-type="add-to-cart-form"] .product-variant-id')
          const full_gift = el ? el.getAttribute('data-full-gift') : null
          if (full_gift){
            const cartItems = [
              {
                id: Number(full_gift),
                quantity: quantity,
                properties: {}
              }
            ]
            shopifyCartAdd({ items: cartItems }).then((d) => {
              if(this.cart) {
                this.cart.renderContents( r.items.concat(d.items))
              } else {
                window.location.href = '/cart'
              }
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }).catch((err) => {
              if(this.cart) {
                this.cart.renderContents(r)
              } else {
                window.location.href = '/cart'
              }
              this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            })
          } else {
            if(this.cart) {
              this.cart.renderContents(r)
            } else {
              window.location.href = '/cart'
            }
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          // 数据埋码
          this.GAEvent({
            "product_spu_name": $('.product__title').text(), //识别页面产品spu标题名称text
            "module": "Product Selection",//固定模块命名Product Selection
            "options": this.currentVariant?.title, //主体产品sku文本text
            "quantity": document.querySelector('quantity-input[data-mian-product-quantity]')?.querySelector('input')?.value, // 识别主体产品加购数量
            "add_on": `${accesorries_title_str.substring(0, accesorries_title_str.length -1)}`, //捆绑产品sku文本text，格式为：“产品sku文本text*数量*价格，产品sku文本text*数量*价格，产品sku文本text*数量*价格，...”
            "options_price": formatMoney(this.currentVariant?.price, window?.pageInfo?.currency?.money_format), //主体产品现价（黑色字体价格），当地货币
            "button_name": $('.product-form__submit[type="submit"]')?.text()?.trim(), // 识别加购add to cart/buy it now按钮 文本名称，根据业务配置的文本呈现
          })

        }).catch(err => {
          this.handleErrorMsg(err.statusText)
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        })
      }

      // Buy it now
      async handleBuy(e) {
        e.preventDefault()

        let items = []
        let str = '' // 容错处理

        let main_sku_quantity = 1 // 数据埋码 主体产品加购数量
        let accesorries_title_str = '' // 数据埋码，收集所有捆绑产品 title

        // 当前商品变体 ID
        const variantId = this.form.querySelector('[name=id]').value

        // 买赠
        const el = document.querySelector('product-form form[data-type="add-to-cart-form"] .product-variant-id')
        const full_gift = el ? el.getAttribute('data-full-gift') : null

        // 如果 配置了 数量选择器，则取实时数量
        if (document.querySelector('quantity-input[data-mian-product-quantity]')) {
          main_sku_quantity = document.querySelector('quantity-input[data-mian-product-quantity]').querySelector('input').value
          items.push({
            id: variantId,
            quantity: document.querySelector('quantity-input[data-mian-product-quantity]').querySelector('input').value,
            properties: {},
          })
          if(full_gift) {
            items.push({
              id: Number(full_gift),
              quantity: main_sku_quantity,
              properties: {}
            })
            str = `/cart/${variantId}:${main_sku_quantity},${Number(full_gift)}:${main_sku_quantity},`
          } else {
            str = `/cart/${variantId}:${main_sku_quantity},`
          }

        } else {
          main_sku_quantity = 1
          items.push({
            id: variantId,
            quantity: 1,
            properties: {},
          })
          if(full_gift) {
            items.push({
              id: Number(full_gift),
              quantity: main_sku_quantity,
              properties: {}
            })
            str = `/cart/${variantId}:1,${Number(full_gift)}:1,`
          } else {
            str = `/cart/${variantId}:1,`
          }
        }

        const properties = window.btoa(unescape(encodeURIComponent(JSON.stringify({
          Action: 'bundled sale'
        }))))

        if (this.dom__bundled && this.dom__bundled.querySelectorAll(":checked").length > 0) {
          this.dom__bundled.querySelectorAll(":checked").forEach(item => {
            const quantityInput = item.parentElement.parentElement.querySelector('[data-quantity-input]')
            items.push({
              id: quantityInput.dataset.skuId,
              quantity: quantityInput.value,
              properties: { Action: 'bundled sale' }
            })
            str += `${quantityInput.dataset.skuId}:${quantityInput.value},`
            accesorries_title_str += `${quantityInput.dataset.skuTitle}*${quantityInput.value}*${quantityInput.dataset.skuPrice},`
          })
        }


        try {
          // 生成 checkout url，并跳转
          const checkoutUrl = await createCartAndCheckout(items)
          if (checkoutUrl) {
            window.location.href = checkoutUrl
          }
        } catch (err) {
          // 容错处理
          if (this.dom__bundled && this.dom__bundled.querySelectorAll(":checked").length > 0) {
            str = `${str.substring(0, str.length -1)}?traffic_source=buy_now&properties=${properties}`
          } else {
            str = `${str.substring(0, str.length -1)}?traffic_source=buy_now`
          }
          window.location.href = str
        } finally {
          // 数据埋码
          this.GAEvent({
            "product_spu_name": $('.product__title').text(), //识别页面产品spu标题名称text
            "module": "Product Selection",//固定模块命名Product Selection
            "options": this.currentVariant?.title, //主体产品sku文本text
            "quantity": main_sku_quantity, // 识别主体产品加购数量
            "add_on": `${accesorries_title_str.substring(0, accesorries_title_str.length -1)}`, //捆绑产品sku文本text，格式为：“产品sku文本text*数量*价格，产品sku文本text*数量*价格，产品sku文本text*数量*价格，...”
            "options_price": formatMoney(this.currentVariant?.price, window?.pageInfo?.currency?.money_format), //主体产品现价（黑色字体价格），当地货币
            "button_name": $('.buy-it-now-custom-btn')?.text()?.trim(), // 识别加购add to cart/buy it now按钮 文本名称，根据业务配置的文本呈现
          })

          // 新 checkout 数据埋码
          this.GABeginCheckoutEvent({
            "module": $('.product__title').text(), //识别页面产品spu标题名称text
            "position": this.currentVariant?.title, //主体产品sku文本text
            "accesorries": `${accesorries_title_str.substring(0, accesorries_title_str.length -1)}`, //  捆绑产品sku文本text
            "button_name": "BUY IT NOW", //  按钮固定文本名称
          })
        }
      }
    })
  }

  // 商品描述
  if (!customElements.get('product-description')) {
    customElements.define('product-description', class ProductDescription extends HTMLElement {
      constructor() {
        super()

        this.contentDOM = this.querySelector('.description-content')
        this.viewMoreBtn = this.querySelector('button[data-view-more-text]')
      }
      connectedCallback() {
        this.init()
      }
      init() {
        const { scrollHeight, offsetHeight } = this.contentDOM;

        if (scrollHeight > offsetHeight) {
          this.viewMoreBtn.style.display = 'block';

          const updateViewMore = () => {
            const { viewMoreText, hideText, showAllDes } = this.viewMoreBtn.dataset;
            if (showAllDes === 'true') {
              this.contentDOM.style.maxHeight = 'none';
              this.viewMoreBtn.classList.add('active');
              this.viewMoreBtn.querySelector('span').innerText = `${hideText}`;
              this.viewMoreBtn.style.display = 'none';
            } else {
              this.contentDOM.style = '';
              this.viewMoreBtn.classList.remove('active');
              this.viewMoreBtn.querySelector('span').innerText = `${viewMoreText}`;
            }
          };

          updateViewMore();

          this.viewMoreBtn.onclick = e => {
            const target = e.target.tagName === 'I' || e.target.tagName === 'SPAN' ? e.target.parentElement : e.target
            const { viewMoreText, hideText, } = target.dataset

            if (target.classList.contains('active')) {
              target.classList.remove('active')
              this.contentDOM.style = ''
              target.querySelector('span').innerText = `${viewMoreText}`
            } else {
              target.classList.add('active')
              this.contentDOM.style.maxHeight = 'none'
              target.querySelector('span').innerText = `${hideText}`

              // 数据埋码，仅展开时触发
              this.GAEvent({
                "product_spu_name": $('.product__title').text(), //识别页面产品spu标题名称text
                "module": "Text Display",//固定模块命名
                "button_name": viewMoreText, // 展开文字名称learn more
              })
            }
          }
        }
      }
      // 数据埋码
      GAEvent(params) {
        if (window.dataLayer || Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ "event_parameters": null });
          window.dataLayer.push({
            "event":"ga4Event",
            "event_name":"products_details_page_user_clicks",
            "event_parameters":{
              "current_page": window.location.href, // current page url
              ...params
            }
          })
        }
      }
    })
  }

  // 到货提醒
  if (!customElements.get('product-shortage')) {
    customElements.define('product-shortage', class ProductShortage extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', this.bindEvents);
      }

      bindEvents() {
        if (this.querySelector(".product-shortage-container")) {
          this.shortage = this.querySelector(".product-shortage-container")
          const strings = this.strings = {
            title: this.shortage.getAttribute("data-title"),
            content: this.shortage.getAttribute("data-content"),
            email_placeholder: this.shortage.getAttribute("data-email_placeholder"),
            shortage_policy: `${this.shortage.getAttribute("data-shortage_policy")}`,
            email_empty_info: `${this.shortage.getAttribute("data-email_empty_info")}`,
            email_error_info: `${this.shortage.getAttribute("data-email_error_info")}`,
            policy_empty_info: `${this.shortage.getAttribute("data-policy_empty_info")}`,
            shortage_submit: `${this.shortage.getAttribute("data-shortage_submit")}`,
            shortage_reminds_success: `${this.shortage.getAttribute("data-shortage_reminds_success")}`,
            shortage_reminds_error: `${this.shortage.getAttribute("data-shortage_reminds_error")}`,
          }
          const variant_obj = {
            sku: this.shortage.getAttribute("variant-sku"),
            sku_goods_name: this.shortage.getAttribute("variant-sku_goods_name"),
            goods_name: this.shortage.getAttribute("variant-goods_name"),
            source: this.shortage.getAttribute("variant-source"),
            cr: window.pageInfo.cr,
            variant_id: this.shortage.getAttribute("variant-id"),
            goods_url: window.location.pathname.replace("/products/", "")
          }

          const onsubmitcall = (params) => {
            if (params.response && params.response.code === 200) {
              const msg = document.querySelector("product-shortage .product-shortage-container").getAttribute("data-shortage_reminds_success") || 'Success'
              pushSuccessMessage(msg);
              $(".popup__product-shortage").find(".close").trigger('click');
            } else {
              const msg = document.querySelector("product-shortage .product-shortage-container").getAttribute("data-email_error_info") || params?.response?.message
              pushErrorMessage(msg);
            }
          }

          ZModle.getInstance(
            `<div class="flex flex-col">
                  <div class="title">${strings.title}</div>
                  <div class="subtitle">${strings.content}</div>
                  <jky-form data-scroll="false" onsubmitcall="" jky-form-id="product-shaortage-form" class="">
                    <form data-action="/v1/notice/add">
                      <div class="newbee-form newbee-form_shortage">
                        <div class="form-row flex full">
                            <div class="form-item required" data-field="input">
                                <input type="email" id="email" name="email"
                                    placeholder="${strings.email_placeholder}"
                                    data-error="${strings.email_empty_info}" data-value="email" data-reg="email"
                                    data-regerror="${strings.email_error_info}">
                            </div>
                        </div>

                        <div style="margin-top: 6px;" class="form-row form-row_check_box flex full">
                                <div
                                    class="form-item required"
                                    data-field="check_box"
                                    data-error="${strings.policy_empty_info}"
                                >
                                    <jky-checkbox class="jky-checkbox_shortage jky-checkbox">
                                        <label class="jky-checkbox">
                                            <span class="jky-checkbox-input">
                                              <input type="checkbox" class="jky-checkbox-original" data-value="agree_recevie_shortage">
                                              <span class="jky-checkbox-inner"></span>
                                            </span>

                                            <span class="jky-checkbox-label">
                                              <span class="jky-agree">${strings.shortage_policy}</span>
                                            </span>
                                        </label>
                                    </jky-checkbox>
                                </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_sku" name="sku"
                                  data-error="" data-value="sku" data-reg="" value="${variant_obj.sku}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_sku_goods_name" name="sku_goods_name"
                                  data-error="" data-value="sku_goods_name" data-reg="" value="${variant_obj.sku_goods_name}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_goods_name" name="goods_name"
                                  data-error="" data-value="goods_name" data-reg="" value="${variant_obj.goods_name}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_source" name="source"
                                  data-error="" data-value="source" data-reg="" value="${variant_obj.source}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_cr" name="cr"
                                  data-error="" data-value="cr" data-reg="" value="${variant_obj.cr}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_variant_id" name="variant_id"
                                  data-error="" data-value="variant_id" data-reg="" value="${variant_obj.variant_id}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div style="display: none;" class="form-row flex  full">
                          <div class="form-item form-item_const" data-field="input">
                              <input type="text" id="shortage_goods_url" name="goods_url"
                                  data-error="" data-value="goods_url" data-reg="" value="${variant_obj.goods_url}"
                                  data-regerror="">
                          </div>
                        </div>

                        <div class="newbee-form_submit flex" style="justify-content: flex-start;">
                            <button class="form_sub_btn z-button-middle">${strings.shortage_submit}</button>
                        </div>
                      </div>
                    </form>
                  </jky-form>
                </div>
                `,
            {
              id: `popup__product-shortage--${variant_obj.variant_id}`,
              class: "popup__product-shortage",
              cb: (el) => {
                const jkyform = el.querySelector("jky-form")
                jkyform.setAttribute("onsubmitcall", onsubmitcall)
              }
            }
          )
        }
      }
    })
  }

  // 注册 jdgm 插件事件
  function registerJdgmPluginEvent() {
    if ($(".jdgm-prev-badge").length > 0) {
      $(".jdgm-prev-badge").off("click").on("click", function() {
        // 4.0 商详页
        $('.navli[data-cate]')?.last()?.trigger("click");
        $('.jky-tabs-item[data-cate]')?.last()?.trigger("click");
        // 3.0 商详页
        $('.J-tabs-point')?.find('li[data-point="reviews"]')?.trigger("click");
      })
    }
  }
  // Initial check
  registerJdgmPluginEvent()

  if (document.querySelector('.main-product--app-box')?.length > 0) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          registerJdgmPluginEvent();
        }
      })
    }).observe(document.querySelector('.main-product--app-box'), { childList: true, subtree: true })
  }
  // faq
	if (!customElements.get('product-faq-columns')) {
		customElements.define('product-faq-columns', class ProductFaq extends HTMLElement {
			constructor() {
				super()

				this.selectors = {
					faq_columns: $(this).find(".produc-detail--faq-left"),
					faq_columns_name: $(this).find(".produc-detail--faq-left .faq-category-name"),
					faq_content: $(this).find(".produc-detail--faq-right ul[data-index]"),
					faq_content_header: $(this).find(".produc-detail--faq-right ul[data-index] li .faq-header"),
					more_btn: $(this).find(".faq--more")
				}
				this.init()
			}

			init() {
				const _this = this

				// FAQ 按分类展示
				if (this.selectors.faq_columns?.length > 0) {
					this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
					this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()

					// faq分类 点击
					this.columnClick()
				}
				// FAQ 不按分类展示
				else {
					// 先收起全部
					this.selectors.faq_content_header.each(function () {
						$(this).next('.faq-content').slideUp()
						$(this).removeClass("active")
					})

					// 默认展开第一个
					this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
					this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()
				}


				// faq header 点击
				this.selectors.faq_content_header.click(function () {
					$(this).next('.faq-content').slideToggle()
					$(this).toggleClass("active")

					const activeElement = _this.selectors.faq_columns_name.filter(function() {
						return $(this).hasClass("active");
					});
					// 数据埋码
					gaProductDetailDataLayer({
						"module": "FAQ", // 固定名称FAQ
						"position": _this.selectors.faq_columns?.length > 0 ? activeElement.text().trim() : null, // 左侧分类名称文本text。若无配置则无需识别。
						"button_name": $(this).text().trim(), // 问题文本内容text
						"type": $(this).hasClass("active") ? "open" : "fold", // 折叠fold，展开open。
					})
				})

				// 跳转链接按钮 点击
				if (this.selectors.more_btn) {
					this.selectors.more_btn.click(function() {
						const activeElement = _this.selectors.faq_columns_name?.filter(function() {
							return $(this).hasClass("active");
						});
						// 数据埋码
						gaProductDetailDataLayer({
							"module": "Parameter", // 固定名称Parameter
							"position": activeElement?.text()?.trim() || null, // 左侧分类名称文本text。若无配置则无需识别。
							"button_name": $(this)?.text()?.trim(), // 按钮名称文本text
							"link": $(this).attr('href'), // 跳转链接
						})
					})
				}
			}
			columnClick() {
				const _this = this
				const columnsContainer = this.selectors.faq_columns.get(0)
				const len = this.selectors.faq_columns_name.length

				this.selectors.faq_columns_name.click(function() {
					if ($(this).hasClass('active')) {
						// 滚动到容器顶部
						window.scrollTo({
							top: _this.getElementTopPosition(),
							behavior: "smooth"
						})
						return
					}

					$(this).addClass('active')
					$(this).siblings().removeClass('active')

					const index = $(this).data('index')
					const viewMoreLink = $(this).data('view-more-link')

					_this.selectors.faq_content.hide()
					_this.selectors.faq_content.eq(index).show()

					if (viewMoreLink) {
						_this.selectors.more_btn.css('display', 'block');
						_this.selectors.more_btn.attr('href', viewMoreLink)
					} else {
						_this.selectors.more_btn.hide()
					}


					// 计算目标元素相对于容器的偏移量，使其水平居中
					const element = $(this).get(0)
					const offsetLeft = element.offsetLeft - columnsContainer.offsetWidth / 2 + element.offsetWidth / 2;

					// 使用 scrollLeft 平滑滚动
					columnsContainer.scrollTo({
						left: offsetLeft,
						behavior: "smooth"
					});

					// 滚动到最后一个了，去掉 after 伪类
					if (index === len - 1) {
						columnsContainer.parentElement.classList.add('no-after')
					} else {
						columnsContainer.parentElement.classList.remove('no-after')
					}

					// 先收起全部
					_this.selectors.faq_content_header.each(function () {
						$(this).next('.faq-content').slideUp()
						$(this).removeClass("active")
					})

					// 展开当前
					_this.selectors.faq_content.eq(index).find('.faq-header').eq(0).addClass("active")
					_this.selectors.faq_content.eq(index).find('.faq-content').eq(0).slideDown()

					// 滚动到容器顶部
					window.scrollTo({
						top: _this.getElementTopPosition(),
						behavior: "smooth"
					})

					// 数据埋码
					gaProductDetailDataLayer({
						"product_spu_name": $(this).data('product-title'), //识别页面产品spu标题名称text
						"module": "FAQ", // 固定名称FAQ
						"position": $(this)?.text(), // 左侧分类名称文本text。若无配置则无需识别。
					})
				})
			}
			getElementTopPosition() {
				const rect = this.getBoundingClientRect()  // 获取元素相对于视口的位置
				const tabsH = document.querySelector('.product-tabs-container')?.getBoundingClientRect()?.height || 0
				return rect.top + window.scrollY - tabsH  // 元素距离页面顶部的高度
			}
		})
	}
  try {
    document.querySelectorAll(".five-kwh-banner").forEach((el) => {
      if (el.dataset.initialized !== "true") {
        el.dataset.initialized = "true";
        new RegularBanner(el);
      }
    });
  } catch (error) {
    console.log("new-product RegularBanner error", error)
  }
})
